<template>
  <div>
    <!--标题-->
    <div class="detailsTitle">
      <h4>派车管理</h4>
    </div>
    <!--查询条件-->
    <div class="searchBox" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="100px" size="mini">
        <div class=" inpBox">
          <el-form-item label="计划时间:" prop="collectPlanTime">
                <el-date-picker
                  placeholder="选择日期"
                  v-model="searchFrom.collectPlanTime"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  >
                </el-date-picker>
             </el-form-item>
               <el-form-item label="客户名称:" prop="customerName">
                <el-input  placeholder="" maxlength="100" v-model="searchFrom.customerName"></el-input>
              </el-form-item>
              <el-form-item label="合同编号:" prop="contractNo">
                <el-input  placeholder="" maxlength="100" v-model="searchFrom.contractNo"></el-input>
              </el-form-item>
              <el-form-item label="流向:" prop="flowtoType">
                <el-select v-model="searchFrom.flowtoType" placeholder="请选择">
                  <el-option
                    v-for="(item,index) in liuXiangOptions"
                    :key="index"
                    :label="item.showName"
                    :value="item.itemNo">
                  </el-option>
                </el-select>
              </el-form-item>
        </div>
       <div class="searchBtnBox">
        <el-form-item>
          <el-button type="primary"  @click="searchClick" btnCode='00DP002B001' v-if="btnFlg[0]">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="chongZhiClick" btnCode='00DP002B002' v-if="btnFlg[1]">重置</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="duoHeTongClick" btnCode='00DP002B003' v-if="btnFlg[2]">多合同派一车</el-button>
        </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table
        :data="tableList"
        ref="table"
        border
        bordersize="mini"
        height="100%"
        style="width: 100%;margin-top:10px;"
        center
        @selection-change="handleSelectionChange"
        @row-click="handleRowClick"
        :header-cell-style="{background:'#F5F5F5',color:'black'}"
        :header-row-style="{height:'45px'}"
        :row-style="{height:'35px'}"
        highlight-current-row>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column  type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
        <el-table-column prop="planStatus"    label="派车情况"  align="center" width="120">
          <template slot-scope="scope"><div>
              <el-button @click="handleClick(scope.row)" type="text"  size="small" btnCode='00DP002B004' v-if="btnFlg[3]">查看</el-button>
              <!--<el-button @click="handleClick(scope.row)" type="text" v-if="scope.row.planStatus>='4'" size="small">查看</el-button>
              <span v-if="scope.row.planStatus<='4'">{{scope.row.planStatusShow}}</span>-->
            </div></template>
        </el-table-column>
        <el-table-column prop="planNo" label="计划编号" width="130" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="customerName" label="客户名称" width="130" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="contractNo"   label="合同号" align="center" width="130" show-overflow-tooltip></el-table-column>
        <el-table-column property="flowtoTypeShow" label="流向"  align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="weightFlg"    label="计重方式" align="center" >
          <template slot-scope="scope"><div>
              <span v-if="scope.row.weightFlg=='A'">实重</span>
              <span v-if="scope.row.weightFlg=='T'">理重</span>
            </div></template>
        </el-table-column>
        <el-table-column prop="planWeight" label="计划量（吨）" align="center" width="140"></el-table-column>
        <el-table-column prop="totalAllowOut"    label="发货量（吨）" align="center" width="140"></el-table-column>
        <el-table-column prop="completeRate"  label="完成率（%）" align="center" width="140"></el-table-column>
        <el-table-column prop="surplusWeight"  label="剩余量（吨）" align="center" width="140"></el-table-column>
        <el-table-column prop="allCarNum" label="已派车次"  align="center" ></el-table-column>
        <el-table-column prop="putCarNum"    label="发运车次" align="center"></el-table-column>
        <el-table-column prop="collectPlanTime"    label="计划日期" align="center" width="140"></el-table-column>

      </el-table>
    </div>
    <!-- 分页 10,25,50,100-->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[10,25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import {
  // eslint-disable-next-line no-unused-vars
  TenantDictionary, // 字典/
  tCollectPlanSeatch // 查询
} from '@/api/zhb'
import { getBtn } from '@/utils/getButton'
export default {
  data () {
    return {
      // 按钮
      btnFlg: [],
      btnIdArr: ['00DP002B001', '00DP002B002', '00DP002B003',
        '00DP002B004', '00DP002B005', '00DP002B006'],
      title: '',
      h: '500px',
      total: 0,
      searchFrom: {
        pageNo: 1,
        pageSize: 10,
        planStatus: '2,4,5',
        PCFlag: 0,
        collectPlanTime: ''
      },
      liuXiangOptions: [],
      value: '',
      tableList: [],
      // 新增
      addShengChengLoading: false,
      addFaBuLoading: false,
      selectionArr: []
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 150) + 'px'
  },
  created () {
    this.getSeatchData(this.searchFrom)
    this.getDictionary()
    this.getToDay()
    this.btnFlg = getBtn(this.btnIdArr, '/dispatchCar')
  },
  methods: {
    // 点击复选框触发，复选框样式的改变
    handleSelectionChange (val) {
      // this.multipleSelection = val;
    },
    // 点击行触发，选中或不选中复选框
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 年月日格式化
    timeStamp: function (value) {
      if (!value) return ''
      var now = new Date(value)
      // console.log('time:' + JSON.stringify(now))
      var year = now.getFullYear()
      var month = now.getMonth() + 1
      if (month < 10) {
        month = '0' + month
      }
      var date = now.getDate()
      if (date < 10) {
        date = '0' + date
      }
      return year + '-' + month + '-' + date
    },
    /**
 * 日期格式化
 */
    dateFormat (date) {
      let format = 'yyyy-MM-dd hh:mm:ss'
      if (date != 'Invalid Date') {
        var o = {
          'M+': date.getMonth() + 1, // month
          'd+': date.getDate(), // day
          'h+': date.getHours(), // hour
          'm+': date.getMinutes(), // minute
          's+': date.getSeconds(), // second
          'q+': Math.floor((date.getMonth() + 3) / 3), // quarter
          'S': date.getMilliseconds() // millisecond
        }
        if (/(y+)/.test(format)) {
          format = format.replace(RegExp.$1,
            (date.getFullYear() + '').substr(4 - RegExp.$1.length))
        }
        for (var k in o) {
          if (new RegExp('(' + k + ')').test(format)) {
            format = format.replace(RegExp.$1,
              RegExp.$1.length == 1 ? o[k]
                : ('00' + o[k]).substr(('' + o[k]).length))
          }
        }
        return format
      }
      return ''
    },
    // 计划开始时间-当前日期早8点
    getToDay () {
      // 早八点之前显示昨天的日期，早八点之后显示今天的日期
      let dateStartStr = this.dateFormat(new Date(new Date(new Date().toLocaleDateString()).getTime() + 28800000)) // 当天的早8点时间戳
      let dateEndStr = this.dateFormat(new Date(new Date(new Date().toLocaleDateString()).getTime() + 43200000 * 3 - 14400000)) // 当天的早8点时间戳
      let nowDate = (new Date()).getTime()
      let morningTime = new Date(dateStartStr).getTime()
      if (nowDate > morningTime) {
        this.searchFrom.collectPlanTime = this.timeStamp(new Date())
      } else {
        // 昨天的时间
        var day1 = new Date()
        day1.setTime(day1.getTime() - 24 * 60 * 60 * 1000)
        var s1 = day1.getFullYear() + '-' + (day1.getMonth() + 1) + '-' + day1.getDate()
        this.searchFrom.collectPlanTime = s1
      }
    },
    // 获取流向字典数据
    getDictionary () {
      TenantDictionary({
        groupNo: 'flowto_type'
      }).then(res => {
        this.liuXiangOptions = res
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 查询接口
    getSeatchData () {
      tCollectPlanSeatch(this.searchFrom).then(res => {
        this.tableList = res.list
        this.total = res.total
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 点击查询按钮
    searchClick () {
      this.getSeatchData(this.searchFrom)
    },
    // 点击重置
    chongZhiClick () {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 10
      }
      this.getSeatchData(this.searchFrom)
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getSeatchData(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getSeatchData(this.searchFrom)
    },
    // 合同列表取消
    heTongQuXiaoClick () {
      this.heTongMark = false
    },
    // 每页条数
    handleSizeChange2 (val) {
      this.heTongFrom.pageSize = val
      // this.getSearchData()
    },
    // 当前页
    handleCurrentChange2 (val) {
      this.heTongFrom.pageNo = val
      // this.getSearchData()
    },
    // 点击列表查看
    handleClick (row) {
      this.$router.push({
        name: 'dispatchCarSee',
        params: {
          rowData: row
        }
      })
    },
    // 点击多合同派一车
    duoHeTongClick () {
      this.selectionArr = this.$refs.table.selection
      if (this.selectionArr.length > 1) {
        let keHuNames = [] // 客户名称
        let heTongNum = [] // 合同号
        let jiHuaBianHao = [] // 计划号
        let flowtoType = [] // 流向
        let liuXiangCode = [] // 流向code
        let shengYuLiang = [] // 剩余量
        let wanChengLv = [] // 完成率
        let weightFlg = []
        for (let i = 0; i < this.selectionArr.length; i++) {
          keHuNames.push(this.selectionArr[i].customerName)
          heTongNum.push(this.selectionArr[i].contractNo)
          jiHuaBianHao.push(this.selectionArr[i].planNo)
          flowtoType.push(this.selectionArr[i].flowtoTypeShow)
          liuXiangCode.push(this.selectionArr[i].flowtoType)
          weightFlg.push(this.selectionArr[i].weightFlg)
          if (this.selectionArr[i].surplusWeight == 0) {
            shengYuLiang.push(this.selectionArr[i].surplusWeight)
          }
          if (this.selectionArr[i].completeRate == 100) {
            wanChengLv.push(this.selectionArr[i].completeRate)
          }
        }
        // 判断是否是同一客户名称和同一流向、计重方式相同
        if (this.isAllEqual(keHuNames) != false && this.isAllEqual(flowtoType) != false) {
          this.$router.push({
            name: 'dispatchCarAddMany',
            params: {
              customerName: keHuNames[0],
              contractNo: heTongNum.toString(),
              planNo: jiHuaBianHao.toString(),
              flowtoType: flowtoType[0],
              liuXiangCode: liuXiangCode[0]
            }
          })
        } else {
          this.$message.error('所选数据客户名称、流向、必须一致！')
        }
        if (shengYuLiang[0] == 0 && wanChengLv[0] == 100) {
          this.$message.error('剩余量为0，完成率为100的数据不能派车！')
        }
      } else {
        this.$message.error('请选择多条数据进行操作！')
      }
    },
    // 判断数组的每一项是否相等
    isAllEqual (array) {
      if (array.length > 0) {
        return !array.some(function (value, index) {
          return value !== array[0]
        })
      } else {
        return true
      }
    }
  }
}
</script>
<style scoped lang='less'>
.inpBox{
  margin: 10px 0 0 -30px;
}
.searchBox{
  margin-left: 10px;
}
 /deep/ .inpBox .el-range-editor--mini .el-input__inner {
   width: 150px;
}
.searchBtnBox{
  margin-top: 10px;
}
.el-table__header tr,
  .el-table__header th {
    padding: 0;
    height: 40px;
}
//  .demo-form-inline .el-form-item{
//   margin-bottom: 17px!important;
// }
</style>
